import { QUERY_FILTERS } from '@/resources/helpers/constants';

export default defineNuxtRouteMiddleware((to, from) => {
  const config = useRuntimeConfig();


  if (to.path !== '/' && to.path?.endsWith('/')) {
    const newPath = to.path.slice(0, -1);
    return navigateTo({ path: newPath, query: to.query }, { redirectCode: 301 });
  }

  if (!config.public.is_production) return;

  // Canonical links should reflect the actual content of the page.
  // Keep only valid filter query parameters and remove unnecessary ones
  // (e.g., utm_source, reload-attempt). 
  // Generate a canonical URL that matches the filtered query 
  // and ensure there’s no trailing slash.

  const noIndexPages = ['/checkout', '/konto', '/payment-processing', '/feedback', '/payment-error'];
  const shouldIndex = !noIndexPages.some((noIndexPath) => to.path.startsWith(noIndexPath));

  if (shouldIndex) {
    // Remove trailing slash
    const normalizedPath = to.path.replace(/\/+$/, '') || '/';

    // Filters only allowed params
    let validQueryEntries = Object.entries(to.query)
      .filter(([key]) => QUERY_FILTERS.includes(key))
      .filter(([, value]) => value !== '' && value !== null && value !== undefined);

    const flatValidQueryEntries = validQueryEntries.flatMap(([key, value]) => {
      if (Array.isArray(value)) {
        return value.map(v => [key, String(v)]);
      }
      return [[key, String(value)]];
    }) as [string, string][];

    // we want that if similar queries are done but in different order
    // only one canonical link is set as content is the same
    // Sort alphabetically by key, then by value

    flatValidQueryEntries.sort(([aKey, aVal], [bKey, bVal]) => {
      if (aKey === bKey) {
        return String(aVal).localeCompare(String(bVal));
      }
      return aKey.localeCompare(bKey);
    });

    const canonicalQuery = new URLSearchParams(flatValidQueryEntries).toString();

    const canonicalBaseUrl = `${config.public.app_url}${normalizedPath}`;
    const canonicalUrl = canonicalBaseUrl + (canonicalQuery ? `?${canonicalQuery}` : '');

    useHead({
      meta: [{ vmid: 'robots', name: 'robots', content: 'index, follow' }],
      link: [
        {
          vmid: 'canonical',
          rel: 'canonical',
          href: canonicalUrl

        }
      ]
    });
  } else {
    useHead({
      meta: [{ vmid: 'robots', name: 'robots', content: 'noindex, nofollow' }]
    });
  }

});
